import { render, staticRenderFns } from "./InStoreCustomers.template.vue?vue&type=template&id=72fd2d86&scoped=true&"
var script = {}
import style0 from "./InStoreCustomers.template.vue?vue&type=style&index=0&id=72fd2d86&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fd2d86",
  null
  
)

export default component.exports